import { purgeReplace, updateOrdering } from "../utils/Utils";
import { showError } from "../ui/Message";
import GenericConditional from "./customer_filters/GenericConditional";
import GenericDateValue from "./customer_filters/GenericDateValue";
import GenericDoubleValue from "./customer_filters/GenericDoubleValue";
import GenericSingleValue from "./customer_filters/GenericSingleValue";
import { FILTER } from "../utils/Struct";
import { pubCall } from "../utils/PubSub";

export default function CustomerFilterEdit(props) {

    const {
        controller = "",
        filter = {},
        callback = () => { },
        where_type = "AND",
        report = {},
        edit = false,
        setReport = () => { }
    } = props;

    let value = filter.value;
    if (filter?.type) {
        value = filter.type;
    }

    const handleSave = (_f, edit = false) => {
        if (_f) {

            callback();

            _f.where_type = where_type;

            let filter_id = ""

            if (edit?.filter_id) {
            filter_id = edit.filter_id;
            _f.type = edit.type;
            } else {
            _f.filter_id = "";
            }

            let _filters = purgeReplace(report.filters, _f, "type", filter_id);
            _filters = updateOrdering(_filters);

            pubCall("report.purgeAndReplaceFilters", { report_id: report.report_id, filters_info: _filters }, (_s, _r) => {
            if (_s) {
                setReport(_r);
                callback()
            } else {
                showError(_r);
            }
            })
        }
        else {
            callback();
        }
    };

    switch (value) { 
        case 1:
            return <GenericDoubleValue controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 150 }} dayParams={{ maxLength: 2, width: 20, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 2:
            return <GenericDoubleValue controller={controller} edit={edit} inputParams={{ maxLength: 20, width: 150, number: false }} dayParams={{ maxLength: 2, width: 20, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 3:
            return <GenericDoubleValue controller={controller} edit={edit} inputParams={{ maxLength: 20, width: 150, number: false }} dayParams={{ maxLength: 2, width: 20, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 4:
            return handleSave({ ...FILTER, type: filter.value });
        case 5:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 120, uppercase: true, }}  filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 6:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 170 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 7:
            return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 170, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
        case 8:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 150 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 9:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 11, width: 150, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} phone={true} />;
        case 10:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 120, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 11:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 120, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 12:    
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 120, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 13:
            return <GenericDateValue controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 14:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 170 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 15:
            return <GenericDateValue controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 16:
            return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 170, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
        case 17:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 10, width: 120, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 18:
            return <GenericConditional controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 19:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 2, width: 20, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 20:
            return handleSave({ ...FILTER, type: filter.value });
        case 21:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 60 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 22:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 100 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 23:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 150 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 24:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 150 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 25:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 150 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 26:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 150 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 27:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 150 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 28:
            return <GenericDateValue controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 29:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 100, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 30:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 170 }} filter={filter} onClose={() => callback()} onSave={handleSave} phone={true} />;
        case 31:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ width: 170 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 32:
            return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 170, uppercase: true, }} filter={filter} onClose={() => callback()} onSave={handleSave} />
        case 33:
            return <GenericConditional controller={controller} edit={edit} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 34:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 170 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 35:
            return <GenericSingleValue controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 170, uppercase: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />
        case 36:
            return handleSave({ ...FILTER, type: filter.value });
        case 37:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ width: 120 }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 38:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 100, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
        case 39:
            return <GenericConditional controller={controller} edit={edit} inputParams={{ maxLength: 13, width: 100, number: true }} filter={filter} onClose={() => callback()} onSave={handleSave} />;
    }

}